import React, { useState } from "react";

const Calculator = () => {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");

  const handleInput = (e) => {
    setInput(e.target.value);
  };

  const calculate = () => {
    try {
      const calculatedResult = eval(input);
      setResult(calculatedResult);
    } catch (error) {
      setResult("Error");
    }
  };

  const handleNumberClick = (number) => {
    setInput(input + number);
  };

  const clearResult = () => {
    setInput("");
    setResult("");
  };

  return (
    <div className="container mx-auto max-w-md p-4 bg-black text-white rounded-md shadow-2xl font-serif">
      <div className="text-3xl font-bold mb-4">Calculator</div>
      <div className="mb-4">
        RESULT:{" "}
        <span className="font-bold text-yellow-400 text-xl ">{result}</span>
      </div>
      <input
        type="text"
        value={input}
        onChange={handleInput}
        className="w-full mb-4 p-2 rounded-md bg-gray-800 text-white"
      />
      <div className="grid grid-cols-4 gap-2">
        <button
          onClick={() => handleNumberClick("7")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          7
        </button>
        <button
          onClick={() => handleNumberClick("8")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          8
        </button>
        <button
          onClick={() => handleNumberClick("9")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          9
        </button>
        <button
          onClick={() => handleNumberClick("*")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          X
        </button>
        <button
          onClick={() => handleNumberClick("4")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          4
        </button>
        <button
          onClick={() => handleNumberClick("5")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          5
        </button>
        <button
          onClick={() => handleNumberClick("6")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          6
        </button>
        <button
          onClick={() => handleNumberClick("/")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          /
        </button>
        <button
          onClick={() => handleNumberClick("1")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          1
        </button>
        <button
          onClick={() => handleNumberClick("2")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          2
        </button>
        <button
          onClick={() => handleNumberClick("3")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          3
        </button>
        <button
          onClick={() => handleNumberClick("+")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          +
        </button>
        <button
          onClick={() => handleNumberClick("0")}
          className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded col-span-2"
        >
          0
        </button>
        <button
          onClick={() => calculate()}
          className="bg-gold hover:bg-yellow-400 text-white font-bold py-2 px-4 rounded col-span-2"
        >
          =
        </button>
        <button
          onClick={() => clearResult()}
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded "
        >
          Clear
        </button>
      </div>
      <div className="text-xs mt-4">
        &copy; {new Date().getFullYear()} VAQEH
      </div>
    </div>
  );
};

export default Calculator;
